<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
  <mat-expansion-panel-header>
    <mat-panel-title>FINANCIALS (BETA)</mat-panel-title>
  </mat-expansion-panel-header>

  <div class="clinical-timeline-info">
    <!-- Summary Section -->
    <div class="billing-summary-box">
      <div class="summary-card" appearance="outlined">
        <div class="summary-content">
          <ng-container *ngIf="isLoadingNewBilling; else summaryContent">
            <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
            <span class="summary-label">Loading billing data...</span>
          </ng-container>
          <ng-template #summaryContent>
            <ng-container *ngIf="totalOutstanding > 0.01">
              <span class="summary-label">Outstanding Balance:</span>
              <mat-chip class="red-chip">{{ totalOutstanding | currency:'R ':'symbol':'1.2-2' }}</mat-chip>
              <!-- <span class="summary-amount warn">{{ totalOutstanding | currency:'R ':'symbol':'1.2-2' }}</span> -->
            </ng-container>
            <ng-container *ngIf="availableCredit > 0.01">
              <span class="summary-label">Available Credit:</span>
              <mat-chip class="green-chip">{{ availableCredit | currency:'R ':'symbol':'1.2-2' }}</mat-chip>
              <!--  <span class="summary-amount primary">{{ availableCredit | currency:'R ':'symbol':'1.2-2' }}</span> -->
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Estimates Section -->
    <div class="list-header expandable" (click)="toggleHeader('quotations')">
      Estimates
      <mat-icon>
        {{ expandedHeader === 'quotations' ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </div>
    <div *ngIf="expandedHeader === 'quotations'" class="full-width p-t-10">
      <ng-container *ngIf="sortedBillingAid.quotations && sortedBillingAid.quotations.length; else noResults">
        <ng-container *ngFor="let group of sortedBillingAid.quotations">
          <div class="date-header">
            <mat-label class="date-label">
              {{ group.date | date: 'longDate' }}
            </mat-label>
          </div>
          <mat-list>
            <ng-container *ngFor="let record of group.records">
              <mat-list-item class="auto-height">
                <div class="panel-name">
                  <p class="p-t-5 m-b-0">#{{ record.billingNumber }}</p>
                  <div>
                    <span *ngIf="isProBonoPayment(record)">Status: <mat-chip class="blue-chip">Pro Bono</mat-chip></span>
                    <span *ngIf="!isProBonoPayment(record)">
                      Estimate Total: <mat-chip>{{ record.totalDue | currency:'R ':'symbol':'1.2-2'
                        }}</mat-chip>
                    </span>
                  </div>
                </div>
                <div class="panel-item">
                  <div class="panel-details">
                    <app-file-gallery [fileObjects]="record.media || []" [deleteEnabled]="false"></app-file-gallery>
                    <div *ngIf="record.hasProcessingPdf" class="processing-indicator">
                      <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
                      <span class="processing-message">Processing documents...</span>
                    </div>
                    <div class="panel-footer">
                      <div>
                        Created By: {{ record.createdBy }} at {{ record.createdAt | date: 'HH:mm' }}
                      </div>
                    </div>
                    <div class="list-actions icons">
                      <button mat-icon-button matTooltip="Send statement via email"
                        [matMenuTriggerFor]="emailMenuQuotation" (click)="$event.stopPropagation()">
                        <mat-icon>mail</mat-icon>
                      </button>
                      <mat-menu #emailMenuQuotation="matMenu" class="p-10 email-menu-panel">
                        <div mat-menu-content (click)="$event.stopPropagation()">
                          <app-recipient-search [patient]="patient" [patientOnly]="true" label="Quick Select Recipient"
                            placeholder="Search for recipient..." (recipientSelected)="onRecipientSelected($event)">
                          </app-recipient-search>
                          <mat-form-field appearance="outline" class="full-width" (keydown)="handleMenuKeydown($event)">
                            <mat-label>Recipient Name</mat-label>
                            <input matInput [(ngModel)]="sendingDetails.name">
                            <button *ngIf="sendingDetails.name" matSuffix mat-icon-button
                              (click)="sendingDetails.name = ''" matTooltip="Clear name">
                              <mat-icon>clear</mat-icon>
                            </button>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Recipient Email</mat-label>
                            <input matInput [(ngModel)]="sendingDetails.email">
                            <button *ngIf="sendingDetails.email" matSuffix mat-icon-button
                              (click)="sendingDetails.email = ''" matTooltip="Clear email">
                              <mat-icon>clear</mat-icon>
                            </button>
                          </mat-form-field>
                          <button mat-raised-button color="primary" class="full-width"
                            (click)="sendingBillingRecord(record)" matTooltip="Send quotation via email">
                            <mat-icon>send</mat-icon> Send Email
                          </button>
                        </div>
                      </mat-menu>
                      <button mat-icon-button matTooltip="Download quotation as PDF"
                        (click)="downloadPdf(getFirstPdfMedia(record.media))">
                        <mat-icon>file_download</mat-icon>
                      </button>
                      <button mat-icon-button matTooltip="Convert to invoice" (click)="convertToInvoice(record)">
                        <mat-icon>transform</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </mat-list-item>
            </ng-container>
          </mat-list>
        </ng-container>
      </ng-container>
    </div>

    <!-- Invoices Section -->
    <div class="list-header expandable" (click)="toggleHeader('invoices')">
      <div>
        Invoices
        <button mat-button (click)="openCapturePayment()" matTooltip="Capture multiple invoice payments">
          <mat-icon>payment</mat-icon>
        </button>
      </div>
      <mat-icon>
        {{ expandedHeader === 'invoices' ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </div>
    <div *ngIf="expandedHeader === 'invoices'" class="full-width p-t-10">
      <ng-container *ngIf="sortedBillingAid.invoices && sortedBillingAid.invoices.length; else noResults">
        <ng-container *ngFor="let group of sortedBillingAid.invoices">
          <div class="date-header">
            <div class="date-label">
              {{ group.date | date: 'longDate' }}
            </div>
          </div>
          <mat-list class="full-width">
            <ng-container *ngFor="let record of group.records">
              <mat-list-item class="auto-height" [class.removed-item]="record.removedAt">
                <div class="panel-name">
                  <div class="panel-name-left">
                    <p class="p-t-5 m-b-0">#{{ record.billingNumber }}</p>



                    <!-- Normal status on the left -->
                    <div>
                      <div *ngIf="record.outstandingBalance <= 0; else showBalance">
                        Status: <mat-chip [class]="getDocumentStatusChipClass(record)">{{ getDocumentStatusLabel(record) }}</mat-chip>
                      </div>
                      <ng-template #showBalance>
                        <div>
                          Balance Due: <mat-chip class="red-chip">{{ record.outstandingBalance |
                            currency:'R ':'symbol':'1.2-2' }}</mat-chip>
                        </div>
                      </ng-template>
                    </div>

                    <!-- Removed status details on the left -->
                    <div *ngIf="record.removedAt" class="removal-details">
                      <ng-container *ngIf="record.RemovedByUser">
                        <small>Removed by: {{ record.RemovedByUser.title }} {{ record.RemovedByUser.name }} {{
                          record.RemovedByUser.surname }} on {{ record.removedAt | date:'longDate' }}</small>
                        <br>
                      </ng-container>
                      <small>Reason: {{ record.removalReason }}</small>
                      <br>
                      <small *ngIf="record.paymentsRemoved" class="payments-removed-warning">
                        ⚠️ Associated payment records were also removed
                      </small>
                    </div>
                  </div>



                  <!-- Badge on the right -->
                  <div class="panel-name-right">
                    <mat-chip *ngIf="record.removedAt" class="removed-chip">
                      {{ record.paymentsRemoved ? 'REMOVED (WITH PAYMENTS)' : 'REMOVED' }}
                    </mat-chip>
                  </div>
                </div>
                <div class="panel-item stack-mobile" *ngIf="!record.removedAt">
                  <div class="panel-details">
                    <app-file-gallery [fileObjects]="record.media || []" [deleteEnabled]="false"></app-file-gallery>
                    <div *ngIf="record.hasProcessingPdf" class="processing-indicator">
                      <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
                      <span class="processing-message">Processing documents...</span>
                    </div>
                    <div class="panel-footer">
                      <div>
                        Created By:
                        {{ record.createdBy || 'Unknown' }} at {{ record.createdAt | date: 'HH:mm' }}
                      </div>
                    </div>
                    <div class="list-actions icons">
                      <!-- Actions for non-removed invoices -->
                      <ng-container *ngIf="!record.removedAt">
                        <button mat-icon-button matTooltip="Send invoice via email"
                          [matMenuTriggerFor]="emailMenuInvoices" (click)="$event.stopPropagation()">
                          <mat-icon>mail</mat-icon>
                        </button>
                        <mat-menu #emailMenuInvoices="matMenu" class="p-10 email-menu-panel">
                          <div mat-menu-content (click)="$event.stopPropagation()">
                            <app-recipient-search [patient]="patient" [patientOnly]="true"
                              label="Quick Select Recipient" placeholder="Search for recipient..."
                              (recipientSelected)="onRecipientSelected($event)">
                            </app-recipient-search>
                            <mat-form-field appearance="outline" class="full-width"
                              (keydown)="handleMenuKeydown($event)">
                              <mat-label>Recipient Name</mat-label>
                              <input matInput [(ngModel)]="sendingDetails.name">
                              <button *ngIf="sendingDetails.name" matSuffix mat-icon-button
                                (click)="sendingDetails.name = ''" matTooltip="Clear name">
                                <mat-icon>clear</mat-icon>
                              </button>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="full-width">
                              <mat-label>Recipient Email</mat-label>
                              <input matInput [(ngModel)]="sendingDetails.email">
                              <button *ngIf="sendingDetails.email" matSuffix mat-icon-button
                                (click)="sendingDetails.email = ''" matTooltip="Clear email">
                                <mat-icon>clear</mat-icon>
                              </button>
                            </mat-form-field>
                            <button mat-raised-button color="primary" class="full-width"
                              (click)="sendingBillingRecord(record)" matTooltip="Send invoice via email">
                              <mat-icon>send</mat-icon> Send Email
                            </button>
                          </div>
                        </mat-menu>
                        <button mat-icon-button matTooltip="Download invoice as PDF"
                          (click)="downloadPdf(getFirstPdfMedia(record.media))">
                          <mat-icon>file_download</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Remove invoice" (click)="openRemoveInvoiceDialog(record)">
                          <mat-icon>delete</mat-icon>
                        </button>
                        <button mat-button (click)="openCapturePayment(record)" *ngIf="record.outstandingBalance > 0"
                          matTooltip="Capture invoice payment">
                          <mat-icon>payment</mat-icon>
                        </button>
                        <ng-container *ngIf="record.outstandingBalance > 0 && availableCredit > 0.01">
                          <button mat-icon-button matTooltip="Pay from patient credit" [disabled]="applyingCredit"
                            [matMenuTriggerFor]="applyCreditMenu"
                            (click)="creditAmount = suggestedCredit(record); $event.stopPropagation()">
                            <mat-icon>savings</mat-icon>
                          </button>
                          <mat-menu #applyCreditMenu="matMenu" class="p-10">
                            <div mat-menu-content (click)="$event.stopPropagation()">
                              <p class="m-b-10">Credit available: {{ availableCredit | currency:'R ':'symbol':'1.2-2' }}</p>
                              <mat-form-field appearance="outline" class="full-width" (keydown)="$event.stopPropagation()">
                                <mat-label>Amount to apply</mat-label>
                                <input matInput type="number" min="0.01" [max]="suggestedCredit(record)" step="0.01"
                                  [(ngModel)]="creditAmount">
                              </mat-form-field>
                              <button mat-raised-button color="primary" class="full-width"
                                [disabled]="!(creditAmount > 0) || creditAmount > suggestedCredit(record) || applyingCredit"
                                (click)="applyCredit(record)">
                                <mat-icon>savings</mat-icon> Apply credit
                              </button>
                            </div>
                          </mat-menu>
                        </ng-container>
                        <!--  <button mat-icon-button *ngIf="record.outstandingBalance > 0" matTooltip="Settle balance"
                          (click)="openCapturePayment(record)">
                          <mat-icon>attach_money</mat-icon>
                        </button> -->
                      </ng-container>

                      <!-- Actions for removed invoices -->
                      <ng-container *ngIf="record.removedAt">
                        <button mat-icon-button matTooltip="Download invoice as PDF"
                          (click)="downloadPdf(getFirstPdfMedia(record.media))">
                          <mat-icon>file_download</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Recreate invoice" (click)="recreateInvoice(record)">
                          <mat-icon>refresh</mat-icon>
                        </button>
                        {{record.outstandingBalance}}

                      </ng-container>
                    </div>
                  </div>
                </div>
              </mat-list-item>
            </ng-container>
          </mat-list>
        </ng-container>
      </ng-container>
    </div>

    <!-- Receipts Section -->
    <div class="list-header expandable" (click)="toggleHeader('receipts')">
      <div class="statement-header">
        Receipts
      </div>
      <mat-icon>
        {{ expandedHeader === 'receipts' ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </div>
    <div *ngIf="expandedHeader === 'receipts'" class="full-width p-t-10">
      <ng-container *ngIf="sortedBillingAid.receipts && sortedBillingAid.receipts.length; else noResults">
        <ng-container *ngFor="let group of sortedBillingAid.receipts">
          <div class="date-header">
            <mat-label class="date-label">
              {{ group.date | date: 'longDate' }}
            </mat-label>
          </div>
          <mat-list>
            <ng-container *ngFor="let record of group.records">
              <mat-list-item class="auto-height" [class.removed-item]="record.removedAt">
                <div class="panel-name">
                  <div class="panel-name-left">
                    <p class="p-t-5 m-b-0">#{{ record.billingNumber }}</p>

                    <!-- Normal status on the left -->
                    <div *ngIf="!record.removedAt">
                      <div>
                        <span *ngIf="isProBonoPayment(record)">Status: <mat-chip class="blue-chip">Pro Bono</mat-chip></span>
                        <span *ngIf="!isProBonoPayment(record)">
                          Amount Paid: <mat-chip class="green-chip">
                            {{ record.subtotal | currency:'R ':'symbol':'1.2-2' }}</mat-chip>
                          <small *ngIf="record.PatientPayment?.paymentMethod"> via {{ record.PatientPayment.paymentMethod }}</small>
                        </span>
                      </div>
                    </div>

                    <!-- Removed status details on the left -->
                    <div *ngIf="record.removedAt" class="removal-details">
                      <ng-container *ngIf="record.RemovedByUser">
                        <small>Removed by: {{ record.RemovedByUser.title }} {{ record.RemovedByUser.name }} {{
                          record.RemovedByUser.surname }} on {{ record.removedAt | date:'longDate' }}</small>
                        <br>
                      </ng-container>
                      <small>Reason: {{ record.removalReason }}</small>
                      <br>
                      <small *ngIf="record.paymentsRemoved" class="payments-removed-warning">
                        ⚠️ Associated invoice records were also removed
                      </small>
                    </div>
                  </div>

                  <!-- Badge on the right -->
                  <div class="panel-name-right">
                    <mat-chip *ngIf="record.removedAt" class="removed-chip">
                      {{ record.paymentsRemoved ? 'REMOVED (WITH PAYMENTS)' : 'REMOVED' }}
                    </mat-chip>
                  </div>
                </div>
                <div class="panel-item stack-mobile" *ngIf="!record.removedAt">
                  <div class="panel-details">
                    <app-file-gallery [fileObjects]="record.media || []" [deleteEnabled]="false"></app-file-gallery>
                    <div *ngIf="record.hasProcessingPdf" class="processing-indicator">
                      <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
                      <span class="processing-message">Processing documents...</span>
                    </div>
                    <div class="panel-footer">
                      <div>
                        Created By: {{ record.createdBy }} at {{ record.createdAt | date: 'HH:mm' }}
                      </div>
                      <div class="edited" *ngIf="record.updatedAt >= record.createdAt">
                        Created {{ record.updatedAt | dateDiff }} ago
                      </div>
                    </div>
                    <div class="list-actions icons">
                      <!-- Actions for non-removed receipts -->
                      <ng-container *ngIf="!record.removedAt">
                        <button mat-icon-button matTooltip="Send receipt via email"
                          [matMenuTriggerFor]="emailMenuReceipts" (click)="$event.stopPropagation()">
                          <mat-icon>mail</mat-icon>
                        </button>
                        <mat-menu #emailMenuReceipts="matMenu" class="p-10 email-menu-panel">
                          <div mat-menu-content (click)="$event.stopPropagation()">
                            <app-recipient-search [patient]="patient" [patientOnly]="true"
                              label="Quick Select Recipient" placeholder="Search for recipient..."
                              (recipientSelected)="onRecipientSelected($event)">
                            </app-recipient-search>
                            <mat-form-field appearance="outline" class="full-width"
                              (keydown)="handleMenuKeydown($event)">
                              <mat-label>Recipient Name</mat-label>
                              <input matInput [(ngModel)]="sendingDetails.name">
                              <button *ngIf="sendingDetails.name" matSuffix mat-icon-button
                                (click)="sendingDetails.name = ''" matTooltip="Clear name">
                                <mat-icon>clear</mat-icon>
                              </button>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="full-width">
                              <mat-label>Recipient Email</mat-label>
                              <input matInput [(ngModel)]="sendingDetails.email">
                              <button *ngIf="sendingDetails.email" matSuffix mat-icon-button
                                (click)="sendingDetails.email = ''" matTooltip="Clear email">
                                <mat-icon>clear</mat-icon>
                              </button>
                            </mat-form-field>
                            <button mat-raised-button color="primary" class="full-width"
                              (click)="sendingBillingRecord(record)" matTooltip="Send receipt via email">
                              <mat-icon>send</mat-icon> Send Email
                            </button>
                          </div>
                        </mat-menu>
                        <button mat-icon-button matTooltip="Download receipt as PDF"
                          (click)="downloadPdf(getFirstPdfMedia(record.media))">
                          <mat-icon>file_download</mat-icon>
                        </button>
                        <ng-container *ngIf="canChangePaymentMethod(record)">
                          <button mat-icon-button matTooltip="Change payment method" [disabled]="changingPaymentMethod"
                            [matMenuTriggerFor]="paymentMethodMenu" (click)="$event.stopPropagation()">
                            <mat-icon>payments</mat-icon>
                          </button>
                          <mat-menu #paymentMethodMenu="matMenu">
                            <button mat-menu-item *ngFor="let method of moneyPaymentMethods"
                              [disabled]="method === record.PatientPayment.paymentMethod"
                              (click)="changeReceiptPaymentMethod(record, method)">
                              {{ method }}
                            </button>
                          </mat-menu>
                        </ng-container>
                      </ng-container>

                      <!-- Actions for removed receipts -->
                      <ng-container *ngIf="record.removedAt">
                        <button mat-icon-button matTooltip="Download receipt as PDF"
                          (click)="downloadPdf(getFirstPdfMedia(record.media))">
                          <mat-icon>file_download</mat-icon>
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </mat-list-item>
            </ng-container>
          </mat-list>
        </ng-container>
      </ng-container>
    </div>

    <!-- Statements Section -->
    <div class="list-header expandable" (click)="toggleHeader('statements')">
      <div class="statement-header">
        Statements
        <button mat-button (click)="openStatementDialog()" matTooltip="Generate Patient Statement">
          <mat-icon>receipt_long</mat-icon>
        </button>
      </div>
      <mat-icon>
        {{ expandedHeader === 'statements' ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    </div>
    <div *ngIf="expandedHeader === 'statements'" class="full-width p-t-10">
      <ng-container *ngIf="sortedBillingAid.statements && sortedBillingAid.statements.length; else noResults">
        <ng-container *ngFor="let group of sortedBillingAid.statements">
          <div class="date-header">
            <mat-label class="date-label">
              {{ group.date | date: 'longDate' }}
            </mat-label>
          </div>
          <mat-list>
            <ng-container *ngFor="let record of group.records">
              <mat-list-item class="auto-height">
                <div class="panel-name">
                  <p class="p-t-5 m-b-0">#{{ record.billingNumber }}</p>
                </div>
                <div class="panel-item">
                  <div class="panel-details">
                    <app-file-gallery [fileObjects]="record.media || []" [deleteEnabled]="false"></app-file-gallery>
                    <div *ngIf="record.hasProcessingPdf" class="processing-indicator">
                      <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
                      <span class="processing-message">Processing documents...</span>
                    </div>
                    <div class="panel-footer">
                      <div>
                        Created By: {{ record.createdBy }} at {{ record.createdAt | date: 'HH:mm' }}
                      </div>
                    </div>
                    <div class="list-actions icons">
                      <button mat-icon-button matTooltip="Send statement via email"
                        [matMenuTriggerFor]="emailMenuStatement" (click)="$event.stopPropagation()">
                        <mat-icon>mail</mat-icon>
                      </button>
                      <mat-menu #emailMenuStatement="matMenu" class="p-10 email-menu-panel">
                        <div mat-menu-content (click)="$event.stopPropagation()">
                          <app-recipient-search [patient]="patient" [patientOnly]="true" label="Quick Select Recipient"
                            placeholder="Search for recipient..." (recipientSelected)="onRecipientSelected($event)">
                          </app-recipient-search>
                          <mat-form-field appearance="outline" class="full-width" (keydown)="handleMenuKeydown($event)">
                            <mat-label>Recipient Name</mat-label>
                            <input matInput [(ngModel)]="sendingDetails.name">
                            <button *ngIf="sendingDetails.name" matSuffix mat-icon-button
                              (click)="sendingDetails.name = ''" matTooltip="Clear name">
                              <mat-icon>clear</mat-icon>
                            </button>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Recipient Email</mat-label>
                            <input matInput [(ngModel)]="sendingDetails.email">
                            <button *ngIf="sendingDetails.email" matSuffix mat-icon-button
                              (click)="sendingDetails.email = ''" matTooltip="Clear email">
                              <mat-icon>clear</mat-icon>
                            </button>
                          </mat-form-field>
                          <button mat-raised-button color="primary" class="full-width"
                            (click)="sendingBillingRecord(record)" matTooltip="Send statement via email">
                            <mat-icon>send</mat-icon> Send Email
                          </button>
                        </div>
                      </mat-menu>
                      <button mat-icon-button matTooltip="Download statement as PDF"
                        (click)="downloadPdf(getFirstPdfMedia(record.media))">
                        <mat-icon>file_download</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </mat-list-item>
            </ng-container>
          </mat-list>
        </ng-container>
      </ng-container>
    </div>


  </div>
</mat-expansion-panel>


<!-- Loading Template -->
<ng-template #listLoading>
  <div class="list-loading">
    <mat-spinner color="primary" diameter="20"></mat-spinner>
  </div>
</ng-template>

<!-- No Results Template -->
<ng-template #noResults>
  <p class="no-records-message">No records found.</p>
</ng-template>